import React, { FunctionComponent } from 'react';
import { Box, Divider, Grid, Link as MaterialLink, Typography } from '@material-ui/core';
import clsx from 'clsx';
import LabelAndPrice from '../../labels/LabelAndPrice';
import expandedSectionStyles from '../ExpandedSectionStyles';
import ColorButton from '../../../../../../../common/components/colorPicker/colorButton/ColorButton';
import { IExteriorColour, IInteriorColour } from '../../../../../../../../../common/model/IColours';
import { CustomiseSections } from '../../../../../../../common/enum/CustomiseSections';
import IndicativeNumber from '../../../../../../../common/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../../react/navigation/useScrollToSection';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface IColoursSectionProps {
  exteriorColour: IExteriorColour;
  interiorColour: IInteriorColour;
  changeAction: (name: string) => void;
  decimalScale: number;
  currency: string;
}

const ColoursSection: FunctionComponent<IColoursSectionProps> = ({
  exteriorColour,
  interiorColour,
  changeAction,
  decimalScale,
  currency,
}) => {
  const styles = expandedSectionStyles();
  const { scrollToDisclaimer } = useScrollToSection();

  return (
    <>
      <Grid item={true} data-test="summary_expanded:section:exterior">
        <Typography variant={'body1'} className={clsx([styles.bolded, styles.subtitle, styles.colour])}>
          <Box display={'flex'} flexDirection={'inline'} component={'span'} className={styles.bolded}>
            <Translation id={'spc.customise.color'} />
            <IndicativeNumber
              dataTest="exteriorColor"
              displayNumber={<Translation id="spc.customise.indicative.exteriorColor" />}
              onClick={scrollToDisclaimer}
            />
          </Box>
        </Typography>
        <Box pl={0.8}>
          <ColorButton
            hexColorCode={exteriorColour.hexColourCode}
            id={exteriorColour.id}
            isActive={true}
            variant={'small'}
            onClick={() => null}
          />
        </Box>
        <LabelAndPrice
          label={exteriorColour.title}
          price={0}
          currency={currency}
          priceType="exterior"
          isMainText={false}
          decimals={decimalScale}
        />
        <MaterialLink
          onClick={() => changeAction(CustomiseSections.EXTERIOR)}
          variant={'helpingText'}
          className={styles.changeAction}
          color={'secondary'}
          underline={'always'}
          data-test={'colour:button:change'}
        >
          <Translation id={'spc.customise.button.change'} />
        </MaterialLink>
      </Grid>
      <Divider />
      <Grid item={true} data-test="summary_expanded:section:interior">
        <Typography variant={'body1'} className={clsx([styles.bolded, styles.subtitle, styles.colour])}>
          <Translation id={'spc.customise.interior'} />
        </Typography>
        <Box pl={0.8}>
          <ColorButton
            colorImageSource={interiorColour?.images[0].url}
            id={interiorColour.id}
            isActive={true}
            variant={'small'}
            onClick={() => null}
          />
        </Box>
        <LabelAndPrice
          label={interiorColour.title}
          price={interiorColour.prices[0] ? interiorColour.prices[0].basePrice : 0}
          currency={currency}
          priceType="fees"
          isMainText={false}
          decimals={decimalScale}
        />
        <MaterialLink
          onClick={() => changeAction(CustomiseSections.INTERIOR)}
          variant={'helpingText'}
          className={styles.changeAction}
          underline={'always'}
          color={'secondary'}
          data-test={'colour:button:change'}
        >
          <Translation id={'spc.customise.button.change'} />
        </MaterialLink>
      </Grid>
    </>
  );
};

export default ColoursSection;
